export default __webpack_public_path__ + "static/media/banner-5.d5b1a6b1.jpg";